import { useTranslation } from 'react-i18next';

interface FooterProps {
  className?: string;
  onDark?: boolean;
}

export function Footer({ className = '', onDark = false }: FooterProps) {
  const { t } = useTranslation();
  return (
    <footer
      className={`flex items-center justify-center gap-2 pt-6 text-xs ${
        onDark ? 'text-white/70' : 'text-conduril-muted'
      } ${className}`}
    >
      <span>{t('common.poweredBy')}</span>
      <a
        href="https://apexiumsystems.com"
        target="_blank"
        rel="noreferrer noopener"
        className="inline-flex items-center transition hover:opacity-80"
        aria-label="Apexium Systems"
      >
        <img src="/apexium-logo.png" alt="Apexium Systems" className="h-16 w-auto rounded" />
      </a>
    </footer>
  );
}
